import { IconButton, MenuOpenIcon, MenuIcon, Tooltip } from "@platform/style";
import React from "react";

export const NavMenuToggleButton = () => {
  const [open, setOpen] = React.useState(true);

  const toggleNavDrawer = () => {
    window.dispatchEvent(new Event("HeaderToAssistant-ToggleNavDrawer"));
  };

  React.useEffect(() => {
    function toggleNavButton(event: any) {
      setOpen(event.detail.open);
    }

    window.addEventListener("AssistantToHeader-ToggleNavButton", toggleNavButton);
    return () => {
      window.removeEventListener("AssistantToHeader-ToggleNavButton", toggleNavButton);
    };
  }, []);

  return (
    <Tooltip
      title={open ? "Close Navigation Menu" : "Open Navigation Menu"}
      placement={"bottom"}
      arrow
    >
      <IconButton
        size="large"
        edge="start"
        sx={{ mr: 1, color: "header.contrastText" }}
        onClick={toggleNavDrawer}
      >
        {open ? <MenuOpenIcon /> : <MenuIcon />}
      </IconButton>
    </Tooltip>
  );
};
